module.exports = __webpack_public_path__ + "img/kaipai.d4e6523b.png";